'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _contactUsModal = require('./contact-us-modal');

var _contactUsModal2 = _interopRequireDefault(_contactUsModal);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ContactUsButton = _react2['default'].createClass({
    displayName: 'ContactUsButton',

    propTypes: {
        'timePeriod': _react2['default'].PropTypes.string,
        'pricingSource': _react2['default'].PropTypes.string,
        'buttonText': _react2['default'].PropTypes.string

    },
    componentDidMount: function componentDidMount() {

        if (window.location.search.indexOf('showContactUs=1') > -1) {
            this.handleClick();
        }
    },
    getInitialState: function getInitialState() {
        return {
            'timePeriod': 'Y'
        };
    },
    handleClick: function handleClick() {
        var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('contact_us_modal');
        _reactDom2['default'].render(_jsx(_contactUsModal2['default'], {
            timePeriod: this.state.timePeriod,
            pricingSource: this.props.pricingSource
        }), attachPoint);
    },
    render: function render() {
        var text = this.props.buttonText !== undefined ? this.props.buttonText : 'Contact Us';
        return _react2['default'].createElement(_button2['default'], { ref: 'contactUsButton', buttonId: 'contactUsButton', buttonText: text, buttonHoverColor: 'cerulean', onClick: this.handleClick });
    }
});

module.exports = ContactUsButton;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/contact-us-button.jsx
 ** module id = 788
 ** module chunks = 0
 **/